<template>
  <div class="flex flex-col gap-6">
    <!-- KPI Cards -->
    <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
      <KpiCard
        :title="
          i18n.t(
            variant === 'tool'
              ? 'browserExtension.sessions'
              : 'browserExtension.totalSessions'
          )
        "
        :value="stats?.metadata?.total_sessions || 0"
        :icon="Activity" />
      <KpiCard
        :title="i18n.t('browserExtension.activeUsers')"
        :value="stats?.metadata?.unique_installations || 0"
        :icon="Users" />
      <!-- 3rd Card Varies -->
      <KpiCard
        v-if="variant === 'deployment'"
        :title="i18n.t('browserExtension.uniqueTools')"
        :value="stats?.metadata?.unique_tools || 0"
        :icon="AppWindow" />
      <KpiCard
        v-else
        :title="i18n.t('browserExtension.activeDays')"
        :value="stats?.metadata?.active_days || 0"
        :icon="Calendar" />
    </div>

    <!-- Heatmap -->
    <div
      class="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800">
      <h3 v-if="title" class="mb-4 font-semibold text-gray-900 dark:text-white">
        {{ title }}
        <span v-if="subtitle" class="ml-2 text-sm font-normal text-gray-500">
          ({{ subtitle }})
        </span>
      </h3>
      <div :class="['w-full overflow-hidden', heightClass]">
        <DailyUsageHeatmap :data="stats?.daily_usages || []" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { Activity, Users, AppWindow, Calendar } from 'lucide-vue-next'
  import KpiCard from './KpiCard.vue'
  import DailyUsageHeatmap from './DailyUsageHeatmap.vue'
  import type { UsageStatsDetails } from '@/client'

  const props = defineProps<{
    stats: UsageStatsDetails | null
    variant: 'deployment' | 'tool'
    title?: string
    subtitle?: string | null
  }>()

  const i18n = useI18n()

  const heightClass = computed(() =>
    props.variant === 'deployment' ? 'h-48' : 'h-44'
  )
</script>
